module.exports = __webpack_public_path__ + "images/emoji/heavy_exclamation_mark.c19f65bb94fb7243a702.png";